import {EMPLOYEE} from './employeeActionTypes';

export function getEmployee(active) {
    const activeFilter = active ? '&filter[status]=active' : ''
    return {
        type: EMPLOYEE.GET_EMPLOYEE,
        payload: {
            client: 'default',
            request: {
                url: `users/search?filter[type]=employee${activeFilter}`,
                method: 'get'
            }
        }
    };
}

export function getCompanyEmployeeList(id) {
    return {
        type: EMPLOYEE.GET_COMPANY_EMPLOYEE_LIST,
        payload: {
            client: 'default',
            request: {
                url: `companies/${id}/employees`,
                method: 'get'
            }
        }
    };
}

export function getCompanyEmployeeInner(companyId, employeeId) {
    return {
        type: EMPLOYEE.GET_COMPANY_EMPLOYEE_INNER,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/${employeeId}`,
                method: 'get'
            }
        }
    };
}

export function getCompanyEmployeeAdding(companyId) {
    return {
        type: EMPLOYEE.GET_COMPANY_EMPLOYEE_ADDING,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/for-adding`,
                method: 'get'
            }
        }
    };
}

export function postCompanyEmployeeInnerEdit(companyId, employeeId, data) {
    return {
        type: EMPLOYEE.POST_COMPANY_EMPLOYEE_INNER,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/${employeeId}`,
                method: 'post',
                data
            }
        }
    };
}
export function postEmployeeAddProjects(companyId,formData) {
    return {
        type: EMPLOYEE.POST_EMPLOYEE_ADD_PROJECTS,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/add/to-projects`,
                method: 'post',
                data: formData
            }
        }
    };
}

export function postCompanyEmployeeCreate(data, id) {
    return {
        type: EMPLOYEE.POST_COMPANY_EMPLOYEE_CREATE,
        payload: {
            client: 'default',
            request: {
                url: `companies/${id}/employees`,
                method: 'post',
                data
            }
        }
    };
}

export function postEmployeeReview(data) {
    return {
        type: EMPLOYEE.POST_EMPLOYEE_REVIEW,
        payload: {
            client: 'default',
            request: {
                url: `employees/review`,
                method: 'post',
                data
            }
        }
    };
}

export function getEmployeeForReview() {
    return {
        type: EMPLOYEE.GET_EMPLOYEE_FOR_REVIEW,
        payload: {
            client: 'default',
            request: {
                url: `employees/for-review`,
                method: 'get'
            }
        }
    };
}

export function patchCompanyEmployeeFire(companyId, employeeId) {
    return {
        type: EMPLOYEE.PATCH_COMPANY_EMPLOYEE_FIRE,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/${employeeId}/fire`,
                method: 'patch'
            }
        }
    };
}

export function patchCompanyEmployeeReturn(companyId, employeeId) {
    return {
        type: EMPLOYEE.PATCH_COMPANY_EMPLOYEE_RETURN,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/employees/${employeeId}/return`,
                method: 'patch'
            }
        }
    };
}

export function clearEmployee() {
    return {
        type: EMPLOYEE.CLEAR_EMPLOYEE,
        payload: {}
    };
}

export function getCompanyEmployeeListPopup(id) {
    return {
        type: EMPLOYEE.GET_COMPANY_EMPLOYEE_POPUP,
        payload: {
            client: 'default',
            request: {
                url: `companies/${id}/employees?filter[status]=active`,
                method: 'get'
            }
        }
    };
}

export function getEmployeeAddList(id, employeeId) {
    return {
        type: EMPLOYEE.GET_EMPLOYEE_LIST_ADDING,
        payload: {
            client: 'default',
            request: {
                url: `companies/${id}/projects/for-employee/${employeeId}`,
                method: 'get'
            }
        }
    };
}

